var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecommendedDriver',{attrs:{"isPublic":true,"prop-recommended-query-params":this.typeNumberQueryParam,"prop-product-name":null}})}
var staticRenderFns = []

export { render, staticRenderFns }